import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const LS_VIBRATION = 'vibration-enabled';
const LS_SOUND = 'sound-enabled';
const LS_JACKPOT_WIN_NOTIFICATIONS = 'jackpot-win-notifications-enabled';
const LS_ANIMATIONS = 'animations-enabled';

// Функция для получения значений из localStorage с дефолтным значением
const getBooleanFromLocalStorage = (key: string, defaultValue?: boolean) => {
  const storedValue = localStorage.getItem(key);
  return storedValue === null && defaultValue !== undefined
    ? defaultValue
    : storedValue === '1';
};

const initializeSettings = () => {
  const vibrationEnabled = getBooleanFromLocalStorage(LS_VIBRATION, true);
  const soundsEnabled = getBooleanFromLocalStorage(LS_SOUND, true);
  const jackpotWinNotificationsEnabled = getBooleanFromLocalStorage(
    LS_JACKPOT_WIN_NOTIFICATIONS,
    true,
  );
  const animationsEnabled = getBooleanFromLocalStorage(LS_ANIMATIONS, true);

  // Инициализация localStorage значений по умолчанию
  if (localStorage.getItem(LS_VIBRATION) === null) {
    localStorage.setItem(LS_VIBRATION, '1');
  }
  if (localStorage.getItem(LS_SOUND) === null) {
    localStorage.setItem(LS_SOUND, '1');
  }
  if (localStorage.getItem(LS_JACKPOT_WIN_NOTIFICATIONS) === null) {
    localStorage.setItem(LS_JACKPOT_WIN_NOTIFICATIONS, '1');
  }
  if (localStorage.getItem(LS_ANIMATIONS) === null) {
    localStorage.setItem(LS_ANIMATIONS, '1');
  }

  return {
    vibration: vibrationEnabled ?? false,
    sounds: soundsEnabled ?? false,
    jackpotWinNotifications: jackpotWinNotificationsEnabled ?? false,
    animations: animationsEnabled ?? false,
  };
};

interface SettingsState {
  vibration: boolean;
  sounds: boolean;
  jackpotWinNotifications: boolean;
  animations: boolean;
}

const initialState: SettingsState = initializeSettings();

export const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    setVibration: (state, action: PayloadAction<boolean>) => {
      state.vibration = action.payload;
      localStorage.setItem(LS_VIBRATION, action.payload ? '1' : '0');
    },

    setSounds: (state, action: PayloadAction<boolean>) => {
      state.sounds = action.payload;
      localStorage.setItem(LS_SOUND, action.payload ? '1' : '0');
    },

    setJackpotWinNotifications: (state, action: PayloadAction<boolean>) => {
      state.jackpotWinNotifications = action.payload;
      localStorage.setItem(LS_JACKPOT_WIN_NOTIFICATIONS, action.payload ? '1' : '0');
    },

    setAnimations: (state, action: PayloadAction<boolean>) => {
      state.animations = action.payload;
      localStorage.setItem(LS_ANIMATIONS, action.payload ? '1' : '0');
    },
  },
});

export const { setVibration, setSounds, setJackpotWinNotifications, setAnimations } =
  settingsSlice.actions;

export default settingsSlice.reducer;
